/* eslint-disable */
export default {
  cancel: 'Annulla',
  close: 'Chiudi',
  ok: 'OK',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"close"@#@ @source: @#@"Close"@#@
// @key: @#@"ok"@#@ @source: @#@"OK"@#@
